import { Component, RefObject, useMemo } from 'react';

import ReactDOM from 'react-dom';

export const useScope = (parentRef?: RefObject<Component | HTMLElement | null>) => {
    const scope = useMemo(() => {
        const ref = parentRef?.current;
        const current = ref ? ReactDOM.findDOMNode(ref) : null; // eslint-disable-line react/no-find-dom-node
        return { current } as RefObject<HTMLElement>;
    }, [parentRef?.current]); // eslint-disable-line react-hooks/exhaustive-deps

    return scope;
};
